import { z } from "zod";

export const PlanSchema = z.object({
  name: z.string().min(1),
  monthlyPriceCents: z.number().int().nonnegative(),
  stripeProductId: z.string().nullable().default(null),
  stripePriceId: z.string().nullable().default(null),
  bullets: z.array(z.string()).default([]),
  showOnPricingPage: z.boolean().default(false),
  isMostPopular: z.boolean().default(false),
  order: z.number().int().default(0),
  archivedAt: z.number().nullable().default(null),
  limits: z
    .object({
      maxUserSeats: z.number().int().nullable().default(null),
      maxJobsPerMonth: z.number().int().nullable().default(null),
      locationsIncluded: z.number().int().default(1),
    })
    .default({ maxUserSeats: null, maxJobsPerMonth: null, locationsIncluded: 1 }),
  // Switch name → on/off; the catalog of switches is planFeatures.ts.
  features: z.record(z.boolean()).default({}),
  createdAt: z.number(),
});
export type Plan = z.infer<typeof PlanSchema>;

// Member-readable mirror of what the tenant is entitled to, recomputed by
// functions whenever plan / flags / integrations change.
export const PublicEntitlementsSchema = z.object({
  planId: z.string().nullable().default(null),
  planName: z.string().default(""),
  features: z.record(z.boolean()).default({}),
  limits: z.record(z.number().nullable()).default({}),
  integrations: z.record(z.boolean()).default({}), // slug -> enabled
  updatedAt: z.number(),
});
export type PublicEntitlements = z.infer<typeof PublicEntitlementsSchema>;

export const TenantBillingConfigSchema = z.object({
  stripeCustomerId: z.string().nullable().default(null),
  stripeSubscriptionId: z.string().nullable().default(null),
  failureMode: z.enum(["banner", "suspend", "email_only"]).default("banner"),
  billingDayAnchor: z.number().int().min(1).max(28).nullable().default(null),
  /** The incidentals card (Clevis Ring pass-through charges); set by the Stripe webhook after the company adds one. */
  cardOnFile: z
    .object({ paymentMethodId: z.string(), brand: z.string().default("card"), last4: z.string().default(""), at: z.number() })
    .nullable()
    .default(null),
  updatedAt: z.number(),
});
export type TenantBillingConfig = z.infer<typeof TenantBillingConfigSchema>;
